export const ENV = 'dev';
export const GENERIC_URL = {
  dev: {
    api: 'https://staging.ambpoker-api.com/',
    socket: 'https://lobby-staging.ambpoker-api.com',
    apkDownload: 'https://staging.ambpoker.com/app/staging/ambpoker.apk',
  },
  uat: {
    api: 'https://api-uat.ambpoker-api.com/',
    socket: 'https://lobby-uat.ambpoker-api.com',
    apkDownload: 'https://uat.ambpoker.com/app/uat/ambpoker.apk',
  },
  prod: {
    api: 'https://ap.ambpoker-api.com/',
    socket: 'https://lobby.ambpoker-api.com/',
    apkDownload: 'https://staging.ambpoker.com/app/production/ambpoker.apk',
  },
  local: {
    api: 'http://172.16.6.124:6688/',
  },
};
export const BASE_URL = GENERIC_URL[ENV].api;
export const SOCKET_URL = GENERIC_URL[ENV].socket;
export const APK_URL = GENERIC_URL[ENV].apkDownload;

export const M_GET = 'GET';
export const M_POST = 'POST';
export const M_PUT = 'PUT';

export const LOGIN = 'auth/login';
export const GET_GAMES = 'game/list/website';
export const CHANGE_USER_PASSWORD = 'user/password/reset';
export const GET_USER_BALANCE = 'user/profile';
export const GET_GAME_VERSION = 'version/fetch';
export const GET_STATUS = 'user/tokenChecker';
export const USER_LOGOUT = 'auth/logout';
export const LAUNCH_GAME = 'game/launch';

export const PUBLIC_KEY_HEADER = '-----BEGIN PUBLIC KEY-----MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDuqq38PkSc0n3IQ8Oe+8siwuv4UwD7Usyn9/KN0n+ZtiRXDpkXeyDLuXqr8O3HLch4Hgj6BmgUIXH9GQ6obVlnseY1x2lz4EbRq8W3VFmQsh+bmRSdCkMbCRvc6iO4mWPRkpBkIstU5R3e65/HyCWEZYRPPgGu35YyAAHfz9+GUwIDAQAB-----END PUBLIC KEY-----';
